<style lang="stylus">
.z-comment
    padding: 14px 0 0
    font-size: 12px
    .commentipt
        margin: 8px 0 0
        // min-height 70px
        // padding-right 15px
        .nofileupcommentipt
            position: relative
            min-height 75px
            .commentiptleft
                // margin-right: 68px
                .ivu-input
                    background: #f0f6fe
                    border-color: transparent
            .addemojiicon
                float right
                width 30px
                height 30px
                margin-top 12px
                margin-right 5px
                text-align center
                position relative
                .ivu-icon
                    font-size 20px
                    color #ccc
                    cursor pointer
                    line-height 30px
                    &:hover
                        color $basecolor
                .emoji
                    position absolute
                    bottom 0
                    left -360px
                    // z-index 2000
                    // position relative
                    

            .activeIcon
                .ivu-icon
                    color $basecolor
                    
            .ivu-btn
                // text-align right
                margin-top 10px
                float right
                // position: absolute
                // bottom:-40px
                // right: 0
                padding: 6px 14px
        .fileupcommentipt
            border: 1px solid #d2d2d2
            border-radius: 3px
            &.iswriting
                border-color: #64cdff
                box-shadow: 0 0 0 2px rgba(61, 193, 255, 0.2)
                .filesee
                    border-color: #64cdff
            textarea
                border: none
                box-shadow: none
            .filesee
                border-top: 1px solid #d2d2d2
                height: 34px
                background: #fff
                & > .ivu-upload
                    display: inline-block
                    float: left
                    width: 46px
                    .fileupicon
                        display: inline-block
                        height: 34px
                        width: 46px
                        line-height: 31px
                        text-align: center
                        cursor: pointer
                        img
                            vertical-align: middle
                    .ivu-upload-list
                        margin-top: 0
                        position: absolute
                        background: #fff
                .commit
                    float: right
                    padding: 0 15px
                    height: 25px
                    margin: 4px 5px 0 0
                .filelistwrap
                    display: inline-block
                    width: 80%
                    height: 34px
                    line-height: 34px
                    & > .fileuplist
                        max-width: 32%
                    .moreupfiles
                        float: left
                        width: 4%
                        height: 34px
                        cursor: pointer
                        position: relative
                        &:hover
                            & > i
                                color: $basecolor
                            .moreupfilespanel
                                display: block
                        & > i
                            font-size: 27px
                            height: 100%
                            vertical-align: middle
                            width: 100%
                            text-align: center
                        .moreupfilespanel
                            display: none
                            width: 252px
                            position: absolute
                            right: 105%
                            top: 0
                            padding: 5px 15px
        .activeIcon
            .ivu-icon
                color $basecolor
    .transition-box
        padding-right 15px
        max-height 400px
    .fileuplist
        padding: 2px 0
        float: left
        width: 100%
        span
            display: block
            max-width: 85%
            float: left
            a
                color: #757575
        i
            font-size: 18px
            vertical-align: text-bottom
            color: #b4c6d1
            cursor: pointer
            margin-left: 2px
            &:hover
                color: #7ec2ec
        .a_down
            padding-left: 9px
            float: left
    .commentlist
        margin: 16px 0 0
        .commenthead
            float: left
            width: 48px
            img
                width: 38px
                height: 38px
                border-radius: 50%
                cursor: pointer
        .commentbody
            margin: 0 0 0 48px
            padding: 0 16px 0 5px
            .content
                white-space: pre-wrap
                word-break: break-word
                word-wrap: break-word
                .name
                    color: $basecolor
            .bottom
                margin: 3px 0 0
                .replywrap
                    float: right
                    a
                        color: #a5a5a5
                        &:hover
                            color: $basecolor !important
                            text-decoration: underline
                    .del
                        margin: 0 0 0 10px
                    .ivu-poptip-body
                        white-space: nowrap
                    .moreupfileschild
                        width: 34px
                        display: inline-block
                        position: relative
                        text-align: center
                        margin: 0 7px 0 0
                        cursor: pointer
                        & > img
                            vertical-align: sub
                        .moreupfileschildpanel
                            display: none
                            position: absolute
                            right: 105%
                            top: 0
                            padding: 5px 15px
                            width: 252px
                            i
                                color: $basecolor
                        &:hover
                            .moreupfileschildpanel
                                display: block
            .commentlistchild
                background: #f5f8f9
                margin: 10px -16px 0 -12px
                padding: 0 16px 0 12px
                .commentlistchildlist
                    padding: 12px 0 12px
                    border-bottom: 1px solid #e4e6e6
                    &:last-child
                        border-bottom: 0
.child-emoji
    border none !important
    background-color transparent
    margin 0 !important
    padding 0 !important
</style>

<template>
    <div class="z-comment">
        <!-- big评论 -->
        <div v-if="haveBigBtn" class="commentipt">
            <div v-if="type == 'keep'" :class="{ iswriting: bigvalwriting}" class="fileupcommentipt">
                <Input v-model.trim="bigval"  @on-focus="bigvalwriting = true" @on-blur="bigvalwriting = false" type="textarea" :autosize="{ minRows: 2,maxRows: 4}" placeholder="评论："></Input>
                <div class="filesee clearfix">
                    <Upload
                        :action="`${imgUrl}/file/upload`"
                        :with-credentials="true"
                        :data="fileup_param"
                        :show-upload-list="true"
                        :on-success="fileUpSuccessBig"
                        :on-error="fileUpError"
                        ref="fileupbig"
                        name="upload">
                        <span title="上传文件" class="fileupicon"><img src="/static/icon/case_file_icon.png"></span>
                    </Upload>
                    <div class="filelistwrap">
                        <p v-if="index < 3" v-for="(file, index) in bigfilesjson" class="fileuplist">
                            <span class="single_ellipsis"><a target="_blank" :href="`${imgUrl}/file/preview/${file.hash}`" :title="file.name">{{file.name}}</a></span>
                            <Icon @click.native="delfileUp(bigfilesjson, index)" title="删除此文件" type="trash-a"></Icon>
                        </p>
                        <div v-if="isbiz && bigfilesjson.length > 3" class="moreupfiles">
                            <Icon type="ios-more"></Icon>
                            <div class="moreupfilespanel floatpanel">
                                <p v-if="index > 2" v-for="(file, index) in bigfilesjson" class="fileuplist">
                                    <span class="single_ellipsis"><a target="_blank" :href="`${imgUrl}/file/preview/${file.hash}`" :title="file.name">{{file.name}}</a></span>
                                    <Icon @click.native="delfileUp(bigfilesjson, index)" title="删除此文件" type="trash-a"></Icon>
                                </p>
                            </div>
                        </div>
                    </div>
                    <Button class="commit" @click="addComment(null, null, null)" type="info">提交</Button>
                </div>
            </div>
            <div v-else class="nofileupcommentipt clearfix">
                
                <div class="commentiptleft ">
                    <Input @on-enter="addComment(null, null, null)" :maxlength="maxlength" v-model.trim="bigval" type="textarea" :autosize="true" :isPrevent="true" placeholder="评论："></Input>
                </div>
                <!-- <Icon type="md-happy" style="font-size: 30px"/> -->
                <Button @click="addComment(null, null, null)" type="info">提交</Button>
                <!-- style="font-size: 30px; color:#ccc" -->
                <!-- :class="{activeIcon: showParentEmoji === true}" -->
                <!-- <a title="发送表情" href="javascript:;" class="addemojiicon" @click="showParentEmoji = !showParentEmoji" >
                    <Icon type="happy-outline"  ></Icon>
                    
                    <div class="emoji" v-if="showParentEmoji">
                        <z_emoji :hiddenIcon="hiddenIcon" @close="closeEmoji('showParentEmoji')" @changecurrentSay="parentEmoji" currentSay=""></z_emoji>
                    </div>
                </a> -->
                <el-popover
                    placement="bottom-end"
                    :visible-arrow="visibleArrow"
                    width="380"
                    trigger="click"
                    popper-class="child-emoji"
                >
                    <a title="发送表情" href="javascript:;" class="addemojiicon" slot="reference" @click="showParentEmoji = !showParentEmoji" :class="{activeIcon: showEmoji === true}">
                        <Icon type="happy-outline"  ></Icon>
                    </a>
                    <z_emoji2 :hiddenIcon="hiddenIcon" @close="closeEmoji('showEmoji')" @changecurrentSay="parentEmoji" currentSay="" ></z_emoji2>

                </el-popover>
                <!-- @getCurrentInputValue="getCurrentInputValue(list.cid, bidx, list)" -->


                
                <!-- <Button type="text">
                    <Icon type="happy-outline" style="font-size: 30px; color:#ccc"></Icon>
                </Button> -->
                
            </div>
        </div>
        <!-- 子评论 -->
        <transition-group tag="div" name="grouplist" class="transition-box">
            <div v-for="(list, bidx) in data.data" :key="type == 'column' ? list.id : list.cid" class="commentlist clearfix">
                <div class="commenthead">
                    <!-- <img @click="$gotov2('/personalpage/personalcenter/' + list.id)" :src="$avatarHash(list.id)"> -->
                    <img v-if="type == 'column'" :src="$avatarHash(list.uid)">
                    <img v-else :src="$avatarHash(list.id)">
                </div>
                <div class="commentbody">
                    <!-- {{list.content}} -->
                    <!-- <p class="content"><a :href="$gotov2('/personalpage/personalcenter/' + list.id, true)" class="name">{{list.name}}</a>：<span v-html="list.content"></span></p> -->
                    <p class="content"><a class="name">{{list.name}}</a>：<span v-html="list.content"></span></p>
                    <p class="bottom clearfix">
                        <span class="time">{{list.time | timeconvert}}</span>
                        <span class="replywrap">
                            <div v-if="isbiz && list.filesjson.length" class="moreupfileschild">
                                <img src="/static/icon/case_file_icon.png">
                                <div class="moreupfileschildpanel floatpanel">
                                    <p v-for="(file, index) in list.filesjson" class="fileuplist">
                                        <span class="single_ellipsis"><a target="_blank" :href="`${imgUrl}/file/preview/${file.hash}`" :title="file.name">{{file.name}}</a></span>
                                        <a target="_blank" class="a_down" :href="`${imgUrl}/file/download/${file.hash}`"><Icon title="下载此文件" type="ios-download-outline"></Icon></a>
                                    </p>
                                </div>
                            </div>
                            <a @click="replyiffn(list.cid)" class="reply" href="javascript:;">回复</a>
                            <a v-if="list.delable || $store.state.mineInfo.id == list.uid" class="del" @click="delComment(list.cid, bidx, null)" href="javascript:;">删除</a>
                        </span>
                    </p>
                    <div v-if="list.cid == selectCid" class="commentipt">
                        <div v-if="type == 'keep'" :class="{ iswriting: list.childvalwriting}" class="fileupcommentipt">
                            <Input v-model.trim="list.childval"  ref="childipt" @on-focus="list.childvalwriting = true" @on-blur="list.childvalwriting = false" type="textarea" :autosize="{ minRows: 2}" :placeholder="'评论 ' + list.name + '：'"></Input>
                            <div class="filesee clearfix">
                                <Upload
                                    :action="`${imgUrl}/file/upload`"
                                    :with-credentials="true"
                                    :data="fileup_param"
                                    :show-upload-list="true"
                                    :on-success="fileUpSuccessChild"
                                    :on-error="fileUpError"
                                    ref="fileupchild"
                                    name="upload">
                                    <span title="上传文件" class="fileupicon"><img src="/static/icon/case_file_icon.png"></span>
                                </Upload>
                                <div class="filelistwrap">
                                    <p v-if="index < 3" v-for="(file, index) in list.childfilesjson" class="fileuplist">
                                        <span class="single_ellipsis"><a target="_blank" :href="`${imgUrl}/file/preview/${file.hash}`" :title="file.name">{{file.name}}</a></span>
                                        <Icon @click.native="delfileUp(list.childfilesjson, index)" title="删除此文件" type="trash-a"></Icon>
                                    </p>
                                    <div v-if="isbiz && list.childfilesjson.length > 3" class="moreupfiles">
                                        <Icon type="ios-more"></Icon>
                                        <div class="moreupfilespanel floatpanel">
                                            <p v-if="index > 2" v-for="(file, index) in list.childfilesjson" class="fileuplist">
                                                <span class="single_ellipsis"><a target="_blank" :href="`${imgUrl}/file/preview/${file.hash}`" :title="file.name">{{file.name}}</a></span>
                                                <Icon @click.native="delfileUp(list.childfilesjson, index)" title="删除此文件" type="trash-a"></Icon>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <Button class="commit" @click="addComment(list.cid, bidx, list)" type="info">提交</Button>
                            </div>
                        </div>
                        <div v-else class="nofileupcommentipt clearfix">
                            
                            <div class="commentiptleft">
                                <Input @on-enter="addComment(list.cid, bidx, list)" :maxlength="maxlength" v-model.trim="list.childval" ref="childipt" type="textarea" :autosize="{ minRows: 1,maxRows: 3}" :isPrevent="true" :placeholder="'评论 ' + list.name + '：'"></Input>
                            </div>
                            <Button @click="addComment(list.cid, bidx, list)" type="info">提交</Button>

                            <el-popover
                                placement="bottom-end"
                                :visible-arrow="visibleArrow"
                                width="380"
                                trigger="click"
                                popper-class="child-emoji"
                            >
                                <a title="发送表情" href="javascript:;" class="addemojiicon" slot="reference" @click="showEmoji = !showEmoji" :class="{activeIcon: showEmoji === true}">
                                    <Icon type="happy-outline"  ></Icon>
                                </a>
                                <z_emoji2 :hiddenIcon="hiddenIcon" @close="closeEmoji('showEmoji')" @changecurrentSay="Emoji" currentSay="" @getCurrentInputValue="getCurrentInputValue(list.cid, bidx, list)"></z_emoji2>

                            </el-popover>
                            <!-- <a title="发送表情" href="javascript:;" class="addemojiicon" @click="showEmoji = !showEmoji" :class="{activeIcon: showEmoji === true}">
                                <Icon type="happy-outline"  ></Icon>
                                
                                <div class="emoji" v-if="showEmoji">
                                    <z_emoji :hiddenIcon="hiddenIcon" @close="closeEmoji('showEmoji')" @changecurrentSay="Emoji" currentSay=""></z_emoji>
                                </div>
                            </a> -->
                        </div>
                    </div>
                    <!-- 子子评论 -->
                    <div class="commentlistchild">
                        <transition-group tag="div" name="grouplist">
                            <div v-for="(li, cidx) in list.sub" :key="type == 'column' ? li.id : li.cid" class="commentlistchildlist">
                                <!-- {{li.content}} -->
                                <!-- <p class="content"><a :href="$gotov2('/personalpage/personalcenter/' + li.id, true)" class="name">{{li.name}}</a> 回复 <a :href="$gotov2('/personalpage/personalcenter/' + li.ruid, true)" class="name">{{li.rname}}</a>：<span v-html="li.content"></span></p> -->
                                <p class="content"><a class="name">{{li.name}}</a> 回复 <a class="name">{{li.rname}}</a>：<span v-html="li.content"></span></p>
                                <p class="bottom clearfix">
                                    <span class="time">{{li.time | timeconvert}}</span>
                                    <span class="replywrap">
                                        <div v-if="isbiz && li.filesjson.length" class="moreupfileschild">
                                            <img src="/static/icon/case_file_icon.png">
                                            <div class="moreupfileschildpanel floatpanel">
                                                <p v-for="(file, index) in li.filesjson" class="fileuplist">
                                                    <span class="single_ellipsis"><a target="_blank" :href="`${imgUrl}/file/preview/${file.hash}`" :title="file.name">{{file.name}}</a></span>
                                                    <a target="_blank" :href="`${imgUrl}/file/download/${file.hash}`"><Icon title="下载此文件" type="ios-download-outline"></Icon></a>
                                                </p>
                                            </div>
                                        </div>
                                        <a @click="replyiffn(li.cid)" class="reply" href="javascript:;">回复</a>
                                        <a v-if="li.delable || $store.state.mineInfo.id == list.uid" class="del" @click="delComment(li.cid, bidx, cidx)" href="javascript:;">删除</a>
                                    </span>
                                </p>
                                <div v-if="li.cid == selectCid" class="commentipt">
                                    <div v-if="type == 'keep'" :class="{ iswriting: list.childvalwriting}" class="fileupcommentipt">
                                        <Input v-model.trim="list.childval"  ref="childipt" @on-focus="list.childvalwriting = true" @on-blur="list.childvalwriting = false" type="textarea" :autosize="{ minRows: 2}" :placeholder="'评论 ' + li.name + '：'"></Input>
                                        <div class="filesee clearfix">
                                            <Upload
                                                :action="`${imgUrl}/file/upload`"
                                                :with-credentials="true"
                                                :data="fileup_param"
                                                :show-upload-list="true"
                                                :on-success="fileUpSuccessChild"
                                                :on-error="fileUpError"
                                                ref="fileupchild"
                                                name="upload">
                                                <span title="上传文件" class="fileupicon"><img src="/static/icon/case_file_icon.png"></span>
                                            </Upload>
                                            <div class="filelistwrap">
                                                <p v-if="index < 3" v-for="(file, index) in list.childfilesjson" class="fileuplist">
                                                    <span class="single_ellipsis"><a target="_blank" :href="`${imgUrl}/file/preview/${file.hash}`" :title="file.name">{{file.name}}</a></span>
                                                    <Icon @click.native="delfileUp(list.childfilesjson, index)" title="删除此文件" type="trash-a"></Icon>
                                                </p>
                                                <div v-if="isbiz && list.childfilesjson.length > 3" class="moreupfiles">
                                                    <Icon type="ios-more"></Icon>
                                                    <div class="moreupfilespanel floatpanel">
                                                        <p v-if="index > 2" v-for="(file, index) in list.childfilesjson" class="fileuplist">
                                                            <span class="single_ellipsis"><a target="_blank" :href="`${imgUrl}/file/preview/${file.hash}`" :title="file.name">{{file.name}}</a></span>
                                                            <Icon @click.native="delfileUp(list.childfilesjson, index)" title="删除此文件" type="trash-a"></Icon>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <Button class="commit" @click="addComment(li.cid, bidx, li)" type="info">提交</Button>
                                        </div>
                                    </div>
                                    <div v-else class="nofileupcommentipt clearfix">
                                        <div class="commentiptleft">
                                            <Input @on-enter="addComment(li.cid, bidx, li)" :maxlength="maxlength" v-model.trim="list.childval" ref="childipt" type="textarea" :autosize="true" :isPrevent="true" :placeholder="'评论 ' + li.name + '：'"></Input>
                                        </div>
                                        <Button @click="addComment(li.cid, bidx, li)" type="info">提交</Button>

                                        <el-popover
                                            placement="bottom-end"
                                            :visible-arrow="visibleArrow"
                                            width="380"
                                            trigger="click"
                                            popper-class="child-emoji"
                                        >
                                            <a title="发送表情" href="javascript:;" class="addemojiicon" slot="reference" @click="showEmoji = !showEmoji" :class="{activeIcon: showEmoji === true}">
                                                <Icon type="happy-outline"  ></Icon>
                                            </a>
                                            <z_emoji2 :hiddenIcon="hiddenIcon" @close="closeEmoji('showEmoji')" @changecurrentSay="Emoji" currentSay="" @getCurrentInputValue="getCurrentInputValue(list.cid, bidx, list)"></z_emoji2>
                                        </el-popover>

                                    </div>
                                </div>
                            </div>
                        </transition-group>
                    </div>
                </div>
            </div>
        </transition-group>
        <div v-if="!data.data.length && !commentLoading" class="nodatalistcry" >
            <img src="/static/img/nodata_cry_icon.png">
            <p>暂时还没有评论！</p>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import z_emoji from '@/components/common/z-emoji';
import z_emoji2 from '@/components/common/z-emojiV2';
import {messageConvert} from '@/common/js/messageConvert';
export default {
    name: 'z-comment',
    data () {
        return {
            imgUrl,
            data: {
                data: []
            },
            url: {
                geturl: '',
                addurl: '',
                delurl: ''
            },
            bigval: '',
            bigfilesjson: [],
            bigvalwriting: false,
            selectCid: '',
            isbiz: false,
            fileup_param: {},
            commentLoading: false,
            showParentEmoji: false, // 父emoji  最顶层
            showEmoji: false, //  子 emoji
            showchildEmoji: false, // 子子 emoji
            hiddenIcon: true,
            messageConvert,
            visibleArrow: false,
            EmojiCode: '', // 当前emoji code
            maxlength: 200
        }
    },
    props: {
        id: {
            type: Number
        },
        type: {
            type: String,
            default: 'posts'    // posts 知识评论 flow 流程评论 keep 跟进记录评论
        },
        haveBigBtn: {
            type: Boolean,
            default: true
        }
    },
    beforeMount() {
        moment.locale('zh-cn')
        if( this.type == "posts" ){
            this.url = {
                geturl: `/post/comments/list/${this.id}`,
                addurl: '/post/comments/add',
                delurl: '/post/comments/del'
            };
        }
        if( this.type == "flow" || this.type == "keep" ){
            this.isbiz = true;
            this.url = {
                geturl: '/biz/comment/list',
                addurl: '/biz/comment/store',
                delurl: '/biz/comment/del'
            };
            this.fileup_param = {
                'about_type': 'biz_keep_comment',
                'about_id': this.id
            };
        }
        if(this.type == "column"){
            this.url = {
                geturl: `/lawArticle/comment/list/${this.id}`,
                addurl: '/lawArticle/comment/add',
                delurl: '/lawArticle/comment/del'
            }
        }

        this.getComment();
    },
    mounted() {

    },
    methods: {
        getComment() {
            let params;
            if( this.isbiz ){
                params = { type: this.type, assid: this.id};
            }
            this.$ajax('get', this.url.geturl, params, 'commentLoading', data => {
                let v = data;
                let users = [];
                let temparr = [];
                if(this.type == "column"){
                    v.data.forEach(e =>{
                        e.sub = e.children;
                        e.time = e.created_at;
                        e.cid = e.id;
                        e.sub.forEach(f =>{
                            f.cid = f.id;
                            f.rname = f.reply_name;
                            f.time = f.created_at;
                        });
                        if(e.sub.length){
                            e.sub.forEach(sub => messageConvert(sub))
                        }
                        temparr.push(messageConvert(e))
                    })
                }else{
                    v.data.forEach(e => {
                        e.childval = '';
                        e.childfilesjson = [];
                        e.childvalwriting = false;
                        if( this.isbiz ){
                            e.cid = e.cmtid;
                            e.id = e.creator_user.id;
                            e.name = e.creator_user.name;
                            e.time = e.created_at;
                            e.filesjson = e.filesjson ? JSON.parse(e.filesjson) : [];
                            e.sub.forEach(f => {
                                f.cid = f.cmtid;
                                f.id = f.creator_user.id;
                                f.name = f.creator_user.name;
                                f.ruid = f.reply_user.id;
                                f.rname = f.reply_user.name;
                                f.time = f.created_at;
                                f.filesjson = f.filesjson ? JSON.parse(f.filesjson) : [];
                            });
                        }
                        if (e.sub.length) {
                            // console.log('12312313')
                            e.sub.forEach(sub => messageConvert(sub))
                            // e.sub = messageConvert(e.sub)
                        }
                        temparr.push(messageConvert(e))
                        users.push(e.id);
                    });  
                }      
                this.data = v;
                this.$emit('bigUsers', users);
            });
        },
        addComment(cid, bidx, list) {
            if (!this.$store.state.loginStatus) {
                this.$Message.warning('请先登录后再进行评论！');
                return false;
            }

            let val;
            let ischild =  bidx === null ? false : true;
            let filesjson;
            if( ischild ){
                if( this.data.data[bidx].childval == '' ){
                    this.$Message.error( '评论内容不能为空！' );
                    return false;
                }
                val = this.data.data[bidx].childval;
                filesjson = this.data.data[bidx].childfilesjson;
                this.$set(this.data.data[bidx], 'childval', '');
                this.$set(this.data.data[bidx], 'childfilesjson', []);
                this.selectCid = '';
            }else{
                if( this.bigval == '' ){
                    this.$Message.error( '评论内容不能为空！' );
                    return false;
                }
                val = this.bigval;
                filesjson = this.bigfilesjson;
                this.bigval = '';
                this.bigfilesjson = [];
            }
            if(this.type == 'column'){
                var params = {
                    art_id: this.id,
                    comment_id:cid,
                    comment_content:val
                }
            }else{
                var params = { pid: this.id, cid: cid, content: val};
            }
            // params = messageConvert(params)
            if( this.isbiz ){
                params = { type: this.type, assid: this.id, content: val, filesjson: JSON.stringify(filesjson)};
                if( ischild ){
                    params = Object.assign({}, params, { rrid: this.data.data[bidx].cid, ruid: list.id});
                }
            }

            this.$ajax('post', this.url.addurl, params, (data) => {
                let obj = {
                    cid: data.cid || data.cmtid,
                    cmtid: data.cid || data.cmtid,
                    content: val,
                    delable: true,
                    id: this.$store.state.mineInfo.id,
                    name: this.$store.state.mineInfo.real_name||this.$store.state.mineInfo.name,
                    time: moment().format('YYYY-MM-DD HH:mm:ss'),
                    filesjson: filesjson,
                };
                if( ischild ){
                    obj.rname = list.name;
                    obj.ruid = list.id;
                    // obj = messageConvert(obj);
                    // this.data.data[bidx].sub.push(obj);
                }else{
                    obj.childfilesjson = [];
                    obj.childvalwriting = false;
                    obj.sub = [];
                    // obj = messageConvert(obj);
                    // this.data.data.push(obj);
                }
                this.data.total += 1;
                console.log('11111',this.data.total);
                this.$emit('changeCommentLength', {id: this.id, total: this.data.total});
                this.$Message.success( '评论成功！' );
                this.getComment();
            });
        },
        delComment(cid, bidx, cidx) {
            this.$Modal.confirm({
                title: '确认对话框',
                content: '确定删除吗？',
                onOk: () => {
                    if(this.type == 'column'){
                        var url = this.url.delurl;
                        var params = {
                            art_id: this.id,
                            comment_id:cid
                        }
                    }else{
                        var url = this.url.delurl + '/' + cid;
                    }
                    this.$http.post(url,params).then(response => {
                        if( response.data.retcode == RETCODE_OK ){
                            // 存在cidx删除子评论 不存在删除根评论 删除根评论时要加上子评论长度
                            if( cidx === null ){
                                this.data.total -= this.data.data[bidx].sub.length + 1;
                                this.data.data.splice(bidx, 1);
                            }else{
                                this.data.total -= 1;
                                this.data.data[bidx].sub.splice(cidx, 1);
                            }
                            this.$emit('changeCommentLength', {id: this.id, total: this.data.total});
                            this.$Message.success( '删除评论成功！' );
                        }else{
                            this.$Message.error( response.data.errmsg );
                        }
                    });
                }
            });
        },
        replyiffn(id) {
            if( this.selectCid == id ){
                this.selectCid = '';
            }else{
                this.selectCid = id;
                this.$nextTick(()=>{
                    this.$refs.childipt[0].focus();
                });
            }
        },
        fileUpSuccessBig(response, file, fileList) {
            if( response.retcode == RETCODE_OK ){
                this.$refs.fileupbig.clearFiles();
                let newfile = {
                    name: file.name,
                    hash: response.hash
                };
                this.bigfilesjson.push(newfile);
            }else{
                this.$Message.error( '上传文件失败！' );
            }
        },
        fileUpSuccessChild(response, file, fileList) {
            if( response.retcode == RETCODE_OK ){
                this.$refs.fileupchild[0].clearFiles();
                let newfile = {
                    name: file.name,
                    hash: response.hash
                };
                this.data.data.forEach(e => {
                    let f = false;
                    if( e.cmtid == this.selectCid ){
                        f = true;
                    }else{
                        e.sub.forEach(i => {
                            if( i.cmtid == this.selectCid ){
                                f = true;
                            }
                        });
                    }
                    if( f ){
                        e.childfilesjson.push(newfile);
                    }
                });
            }else{
                this.$Message.error( '上传文件失败！' );
            }
        },
        fileUpError(error, file, fileList) {
            console.log(error, file, fileList);
        },
        delfileUp(list, idx) {
            this.$Modal.confirm({
                title: '确认对话框',
                content: '确定删除吗？',
                onOk: () => {
                    list.splice(idx, 1);
                }
            });
        },
        parentEmoji(v ) {
            if (this.bigval.length >= 200) return false
            this.bigval += v
        },
        Emoji(v) {

            this.EmojiCode = v
        },
        getCurrentInputValue(cid, bidx, list) {
            if (list.childval.length >= 200) return false
            list.childval += this.EmojiCode
            this.EmojiCode = ''
        },
        closeEmoji(data) {
            this[data] = false
        }
    },
    filters: {
        timeconvert(date) {
            if( moment().diff(moment(date), 'days') <= 3 ){
                return moment(date).fromNow();
            }else{
                return moment(date).format('YY/MM/DD HH:mm:ss');
            }
        }
    },
    components: {
        z_emoji,
        z_emoji2
    }
}
</script>



// WEBPACK FOOTER //
// src/components/post/z-comment.vue